import type { TrackingEventInit, TrackingEvents, TrackingEventsAdditionalData } from "./types";

export class TrackingEvent<
  EventName extends TrackingEvents,
  Additional = EventName extends keyof TrackingEventsAdditionalData ? TrackingEventsAdditionalData[EventName] : never,
> extends Event {
  detail?: { additionalData: Additional };
  constructor(eventName: EventName, eventInitDict: TrackingEventInit<Additional>) {
    super(eventName);
    this.detail = eventInitDict.detail;
  }
}
